export const routes = {
  LOGIN: '/login',
  VERIFY_OTP: '/verify-otp',
  UAE_PASS_CALLBACK: '/auth/uae-pass/callback',
  DASHBOARD: '/dashboard',
  PROPERTIES: '/properties',
  SAVED_PROPERTIES: '/properties/saved',
  PROPERTY_DETAIL: '/properties/:id',
  ORDER_SUCCESS: '/properties/:id/order-success',
  ORDER_DETAIL: '/properties/:id/orders/:orderId',
  MARKETPLACE: '/marketplace',
  PORTFOLIO: '/portfolio',
  MY_ORDERS: '/portfolio/orders',
  INVESTMENT_DETAIL: '/portfolio/investments/:id',
  INVESTMENT_PAYOUTS: '/portfolio/investments/:id/payouts',
  ERROR: '/error',
  NOTFOUND: '/not-found',
  SIGNUP: '/signup',
  UAE_PASS_SIGNUP: '/signup/uae-pass',
  ONBOARDING_WIZARD: '/onboarding',
  RISK_PROFILE: '/risk-profile',
  PROFILE: '/profile',
  DOCUMENT_PREVIEW: '/profile/documents/:title',
  PROFILE_POLICIES: '/profile/policies',
  BANK_ACCOUNTS: '/bank-accounts',
  ADD_BANK_ACCOUNT: '/bank-accounts/add',
  BANK_ACCOUNT_DETAIL: '/bank-accounts/:id',
  SETTINGS: '/settings',
  HELP: '/help',
  HELP_FAQS: '/help/faqs',
  HELP_CONTACT: '/help/contact',
  NOTIFICATIONS: '/notifications',
  WALLET: '/wallet',
  WALLET_TRANSACTIONS: '/wallet/transactions',
  WALLET_TRANSACTION_DETAIL: '/wallet/transactions/:id',
  WALLET_TOKEN_TRANSACTIONS: '/wallet/token-transactions',
  WALLET_DEPOSIT_SUCCESS: '/wallet/deposit/success',
  INVESTMENT_CALCULATOR: '/investment-calculator',
  MARKET_PULSE: '/dashboard/articles',
  MARKET_PULSE_ARTICLE: '/dashboard/articles/:id',
  EXPLORE_VIDEOS: '/dashboard/videos',
} as const
